module["exports"] = [
  "######"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/address/postcode.js
// module id = 1652
// module chunks = 1